export default __webpack_public_path__ + "media/images/images/icons/repo-source-4ce321e4abc0e484c8b08e4bce30df7a.png";